export interface Customer {
  uniqueid: string;
  bill_to_key: string;
  customer_number: string;
  customer_tier: string;
  division: string;
  yoy_growth: number;
  customer_parent: string;
  customer_name: string;
  ttm_sales_customer_number: number;
  ttm_sales_customer_parent: number;
  customer_type: string;
}
export const defaultCustomer: Customer = {
  uniqueid: '',
  bill_to_key: '',
  customer_number: '',
  customer_tier: '',
  division: '',
  yoy_growth: 0,
  customer_parent: '',
  customer_name: '',
  ttm_sales_customer_number: 0,
  ttm_sales_customer_parent: 0,
  customer_type: '',
};

// e = "", DefaultSearchColumn = false },
